/**
 * Merges multiple React refs into a single ref callback.
 */
export function mergeRefs<T = unknown>(
	refs: Array<React.Ref<T> | undefined>,
): React.RefCallback<T> {
	return (value) => {
		refs.forEach((ref) => {
			if (typeof ref === "function") {
				ref(value);
			} else if (ref != null) {
				ref.current = value;
			}
		});
	};
}
